<div class="g-slider-container">
    <app-notification [type]="toasterType.Warning">
        {{ otAgentsTexts.generate_api_key.slider.warning }}
    </app-notification>

    @if (apiKey) {
        <div class="g-field-area">
            <label for="pass-input">
                {{ otAgentsTexts.generate_api_key.slider.api_key }}
            </label>

            <div>
                <app-password-revealer class="g-small-field">
                    <input id="pass-input"
                           type="password"
                           disabled
                           [(ngModel)]="apiKey"
                           class="g-small-field">
                </app-password-revealer>
                <app-ui-button-copy [textToCopy]="apiKey" [showLabel]="false"></app-ui-button-copy>
            </div>
        </div>
    }
</div>
